import { useState } from "react"
import type { SyntheticEvent } from "react"
import { Box, Paper, Tab, Tabs } from "@mui/material"
import { LicenseHealthTab } from "./licenses/LicenseHealthTab"
import { TrainingEngagementTab } from "./training/TrainingEngagementTab"
import { FeatureAdoptionTab } from "./adoption/FeatureAdoptionTab"
import { ExamPerformanceTab } from "./exams/ExamPerformanceTab"

const TAB_LABELS = ["License Utilization", "Training Engagement", "Feature Adoption", "Exam Performance"]

export function AnalyticsTabs() {
  const [activeTab, setActiveTab] = useState(0)
  const [visited, setVisited] = useState<Set<number>>(new Set([0]))

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
    setVisited((prev) => new Set(prev).add(newValue))
  }

  return (
    <>
      <Paper sx={{ display: "flex", flexDirection: "column" }}>
        <Tabs value={activeTab} onChange={handleChange}>
          {TAB_LABELS.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
      </Paper>

      <Box sx={{ mt: 3 }}>
        {visited.has(0) && <Box hidden={activeTab !== 0}><LicenseHealthTab /></Box>}
        {visited.has(1) && <Box hidden={activeTab !== 1}><TrainingEngagementTab /></Box>}
        {visited.has(2) && <Box hidden={activeTab !== 2}><FeatureAdoptionTab /></Box>}
        {visited.has(3) && <Box hidden={activeTab !== 3}><ExamPerformanceTab /></Box>}
      </Box>
    </>
  )
}
